import { loadStripe, type Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe> | null = null;

export function getStripeForCheckout(): Promise<Stripe> {
  if (stripePromise) return stripePromise;

  const attempt = Promise.resolve()
    .then(() => {
      const publishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
      if (!publishableKey) {
        throw new Error('Stripe publishable key is not configured');
      }
      return loadStripe(publishableKey);
    })
    .then((stripe) => {
      if (!stripe) {
        throw new Error('Stripe failed to initialize');
      }
      return stripe;
    });

  stripePromise = attempt;
  void attempt.catch(() => {
    if (stripePromise === attempt) stripePromise = null;
  });

  return attempt;
}
